<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Select } from '@Shelly/shelly-design-system';
	//Types
	import type { LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

	export let controlOption: LocalControlOptions;

	const modeOptions = [
		{
			title: 'RGB',
			value: 'rgb',
		},
		{
			title: 'CCT',
			value: 'cct',
		},
	];
</script>

<div>
	<Text class="mb-s" element="h2">
		{$format('select_mode_property', {
			default: 'Select Mode Property',
		})}:
	</Text>
	<Select
		size="m"
		value={modeOptions.find((i) => i.value == controlOption.params.config.mode) || modeOptions[0]}
		options={modeOptions}
		icon={'fal fa-microchip'}
		on:change={(e) => {
			controlOption.params.config.mode = e.detail['value'];
		}}
		id="select-4r7cdjd"
		aria-label={$format('select_mode_property', {
			default: 'Select Mode Property',
		})}
	/>
</div>
